export const LOGIN_STORE_USER = "LOGIN_STORE_USER";
export const LOGOUT_STORE_USER = "LOGOUT_STORE_USER";
export const UPDATE_STORE_USER_INFO = "UPDATE_STORE_USER_INFO";
export const UPDATE_STORE_ORDER_HISTORY = "UPDATE_STORE_ORDER_HISTORY";
